module.exports = __webpack_public_path__ + "static/media/i-subastas.df859654.pdf";